<template>
<li v-on:click.stop="toggleApplicationSwitch()">
  <a><i class="material-icons right">apps</i>&nbsp;</a>
  <div class="application-switch z-depth-1" v-if="applicationSwitch">
    <a v-if="showSwitchIcon" @click="navigateTo('switch')" class="application-icon">
        <img :src="switchIcon" />
        <label>Switch</label>
      </a>
    <a @click="navigateTo('assets')" class="application-icon" :class="{'not-active': (!userIsSuperAdmin && !userIsAdmin)}">
      <img :src="assetIcon" />
      <label>{{ $t('views.navbar.asset') }}</label>
    </a>
    <a @click="navigateTo('userManagement')" class="application-icon" v-if="userIsSuperAdmin || userIsAdmin">
      <img :src="userIcon" />
      <label>{{ $t('views.navbar.users') }}</label>
    </a>
    <a @click="navigateTo('organisationManagement')" class="application-icon" v-if="userIsSuperAdmin">
      <img :src="assetIcon" />
      <label>{{ $t('views.navbar.organisations') }}</label>
    </a>
    <a @click="navigateTo('reports')" class="application-icon">
      <img :src="assetIcon" />
      <label>{{ $t('views.switch.tabs.reports') }}</label>
    </a>
     <a @click="navigateTo('axleshunt')" class="application-icon" v-if="userHasAxleShunt || userIsSuperAdmin">
      <img :src="axleshuntIcon" />
      <label>{{ $t('views.navbar.axleshunt') }}</label>
    </a>
  </div>
</li>
</template>

<script>
import router from '../../router'
import AuthenticationService from '../../services/AuthenticationService'
import RailObjectService from '../../services/RailObjectService'

export default {
  name: 'ApplicationSwitch',
  data () {
    return {
      showSwitchIcon: false,
      applicationSwitch: false,
      switchIcon: require('@/assets/switch.svg'),
      assetIcon: require('@/assets/asset.svg'),
      userIcon: require('@/assets/users.svg'),
      axleshuntIcon: require('@/assets/SHUNT.svg'),
      userIsSuperAdmin: false,
      userIsAdmin: false,
      userHasAxleCounters: false,
      userHasAxleShunt: false
    }
  },
  mounted: function () {
    this.userIsSuperAdmin = AuthenticationService.getUser().SystemRoleId === 3
    this.userIsAdmin = AuthenticationService.getUser().SystemRoleId === 2
    this.$root.$el.addEventListener('click', this.rootClick)
    this.userHasAxleCounters = RailObjectService.getRailObjects().filter(obj => { return obj.PossObjectCodeId === 11 }).length > 0
    this.userHasAxleShunt = RailObjectService.getRailObjects().filter(obj => { return obj.PossObjectCodeId === 5 }).length > 0
  },
  methods: {
    navigateTo (application) {
      switch (application) {
        case 'assets':
          // router.push('/assets')
          let adminUrl = process.env.VUE_APP_SSO_REDIRECT_URL + '/admin'
          window.location.replace(adminUrl)
          break
        case 'switch':
          router.push('/')
          break
        case 'userManagement':
          router.push('/possusers')
          break
        case 'organisationManagement':
          router.push('/organisations')
          break
        case 'axleshunt':
          router.push('/axleshunt/59077') // default to an axleshunt / hack workaround..
          break
        case 'reports':
          router.push('/reports')
          break
      }
    },
    toggleApplicationSwitch: function () {
      // check if switch icon should be presented
      let routeName = this.$route.name
      if (routeName === 'Organisations management' || routeName === 'users' || routeName === 'Reports') {
        this.showSwitchIcon = true
      } else {
        this.showSwitchIcon = false
      }

      if (!this.applicationSwitch) {
        this.$root.$el.click()
      }
      this.applicationSwitch = !this.applicationSwitch
    },
    rootClick: function () {
      this.applicationSwitch = false
    }
  }
}
</script>

<style>
.application-switch {
  width: 380px;
  left: -282px;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  line-height: initial;
  color: #000;
}

.application-icon {
  height: 130px;
  width: 148px;
  margin: 20px;
  position: relative;
  float: left;
  text-align: center;
}

.application-icon > img
{
  height: calc(100% - 30px);
}

.application-icon > label {
  font-size: 18px;
  text-align: center;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/_ApplicationSwitch.vue